module.exports = __webpack_public_path__ + "media/images/icon__checkmark--white@3x-656c01717a40aa6535aa5ced2447eb41.png";